import React from 'react';
import { SilaButton } from './SilaButton';

interface ChatInputAreaProps {
  newMessage: string;
  setNewMessage: (msg: string) => void;
  sendMessage: () => void;
  isSending: boolean;
}

export const ChatInputArea: React.FC<ChatInputAreaProps> = ({
  newMessage,
  setNewMessage,
  sendMessage,
  isSending,
}) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  };

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    sendMessage();
  };

  return (
    <div className='p-2 bg-white h-full flex flex-col justify-center overflow-hidden'>
      <form onSubmit={onSubmit} className='flex items-center gap-2 h-full'>
        <div className='flex-grow relative h-full flex items-center'>
          <textarea
            className='w-full p-2 bg-gray-100 rounded-xl text-sm border-0 focus:ring-2 focus:ring-orange-200 focus:outline-none transition-all placeholder-gray-400 resize-none h-full max-h-12'
            placeholder='Escribe un mensaje...'
            value={newMessage}
            onChange={(e) => setNewMessage(e.target.value)}
            onKeyDown={handleKeyDown}
            disabled={isSending}
            rows={1}
          />
        </div>
        <SilaButton
          type='submit'
          disabled={!newMessage.trim()}
          isLoading={isSending}
          variant='primary'
          className='rounded-2xl p-3 flex-shrink-0 mb-1'
        >
          <svg
            xmlns='http://www.w3.org/2000/svg'
            fill='none'
            viewBox='0 0 24 24'
            strokeWidth={2.5}
            stroke='currentColor'
            className='w-5 h-5 transform rotate-[-45deg]'
          >
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              d='M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5'
            />
          </svg>
        </SilaButton>
      </form>
    </div>
  );
};
